/**
 * Helper class providing general utility functions
 * @class GeneralHelper
 */
class GeneralHelper {
    /**
     * Alternative to lodash throttle - limits how often a function can be called
     *
     * @param {Function} func - The function to throttle
     * @param {number} timeFrame - The minimum time (in milliseconds) between function executions
     * @returns {Function} - Throttled function that will only execute at most once per timeFrame
     */
    static throttle(func, timeFrame) {
        let lastTime = 0;
        return (...args) => {
            const now = new Date();
            if (now - lastTime >= timeFrame) {
                func(...args);
                lastTime = now;
            }
        };
    }
}

export default GeneralHelper;
